import { createFileRoute } from "@tanstack/react-router";
import { AiRunPage } from "@/features/ai/ai-run-page";

export const Route = createFileRoute("/_authenticated/ai/runs/$aiRunId")({
  head: () => ({ meta: [{ title: "AI run · Rogue Admin" }] }),
  component: AiRunPage,
});
